import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { BASE_URL, ADMIN_URL } from './constant/BaseApiUrl';

export default class ItemConfigurationService {
  getUrlConfigurationItem() {
    return axios.get(`${ADMIN_URL}${ApiKey.CONFIG_FOR_URL}`);
  }

  updateUrlByUrlType(payload: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.CONFIG_FOR_URL}`, payload);
  }

  getListUrlEmail() {
    return axios.get(`${ADMIN_URL}${ApiKey.EMAIL_URLS}`);
  }

  updateUrlEmailByUrlType(payload: any) {
    return axios.post(`${ADMIN_URL}${ApiKey.EMAIL_URLS}`, payload);
  }

  updateVoucher(payload: any) {
    return axios.post(`${ADMIN_URL}${ApiKey.VOUCHER_EMAIL_CONFIG}`, payload);
  }

  getVoucher(type: any) {
    return axios.get(`${ADMIN_URL}${ApiKey.VOUCHER_EMAIL_CONFIG}/${type}`);
  }

  previewVoucherContent(payload: any) {
    return axios.post(`${BASE_URL}${ApiKey.PREVIEW_VOUCHER}`, payload);
  }

  saveSignature(payload: any) {
    return axios.post(`${ADMIN_URL}${ApiKey.SAVE_SIGNATURE}`, payload);
  }

  getAllSignature() {
    return axios.get(`${ADMIN_URL}${ApiKey.SAVE_SIGNATURE}`);
  }

  getSignatureById(id: any) {
    return axios.get(`${ADMIN_URL}${ApiKey.SAVE_SIGNATURE}/${id}`);
  }

  deleteSignatureBy(id: any) {
    return axios.delete(`${ADMIN_URL}${ApiKey.SAVE_SIGNATURE}/${id}`);
  }

  updateStsSignature(id: any, sts: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.SAVE_SIGNATURE}/${id}/status?status=${sts}`);
  }

  getActiveSignature(sts: any) {
    return axios.get(`${ADMIN_URL}${ApiKey.SAVE_SIGNATURE}/list-by-status?sts=${sts}`);
  }

  getListAgency() {
    return axios.get(`${ADMIN_URL}${ApiKey.AGENCY_BLACKLIST}/list-management`);
  }

  addListAgency(payload: any) {
    return axios.post(`${ADMIN_URL}${ApiKey.AGENCY_BLACKLIST}`, payload);
  }

  getAgencyById(id: any) {
    return axios.get(`${ADMIN_URL}${ApiKey.AGENCY_BLACKLIST}/find-by-id?id=${id}`);
  }

  deleteAgency(id: any) {
    return axios.delete(`${ADMIN_URL}${ApiKey.AGENCY_BLACKLIST}/${id}`);
  }
}
